export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const API_ENDPOINT = `${API_URL}/api`;

export const loginAPI = async (username, password) => {
  const response = await fetch(`${API_ENDPOINT}/authenticate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password, rememberMe: true })
  });

  if (!response.ok) {
    throw new Error('Credenciales inválidas o error en el servidor.');
  }

  const data = await response.json();
  
  // JHipster (el backend que probablemente usas) devuelve el token en 'id_token'
  const token = data.id_token;

  if (!token) {
    throw new Error('No se recibió un token de autenticación del servidor.');
  }

  return token;
};